import React from "react";
import { Input } from "./formstyles";

const InputField = ({ ...rest }) => (
    <Input {...rest} />
);

export default InputField;